module.exports = __webpack_public_path__ + "assets/img/h5-list-text-en.bcfd450f.png";